var LocalStorageCouponSessionHandler = /** @class */ (function () {
    function LocalStorageCouponSessionHandler() {
    }
    LocalStorageCouponSessionHandler.prototype.has = function (key) {
        return window.sessionStorage && window.sessionStorage.getItem(key) !== null;
    };
    LocalStorageCouponSessionHandler.prototype.get = function (key) {
        return window.sessionStorage && this.has(key) ?
            window.sessionStorage.getItem(key) :
            '';
    };
    LocalStorageCouponSessionHandler.prototype.set = function (key, value) {
        if (window.sessionStorage) {
            window.sessionStorage.setItem(key, value);
        }
    };
    return LocalStorageCouponSessionHandler;
}());
export default LocalStorageCouponSessionHandler;
